$(document).ready(function () {

$('.product-buy-button').on('click', function(){
  $('.new-secret-button').eq(0).click();
});

  const inputSubs = $(".rc_radio__autodeliver");
  
  // Added by Ivana - the client wanted to have a carousel inside of a section, so I made a snippet with the same carousel structure
    const snippetCarouselItem = $(".owl-carousel.snippet-carousel");
    setTimeout(function () {
        if (snippetCarouselItem) {
            snippetCarouselItem.owlCarousel({
                autoHeight:true,
                autoplay: true,
                loop: true,
                autoplayTimeout: 4000,
                autoplayHoverPause: true,
                nav: true,
                dots: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    600: {
                        items: 1,
                        nav: false,
                        loop: true,
                    },
                    1000: {
                        items: 1,
                        nav: true,
                        loop: true
                    }
                }
            });
        }
    }, 250);
  

  const carouselItem = $(".owl-carousel");
  setTimeout(function () {
    if (carouselItem) {
      carouselItem.owlCarousel({
        autoplay: true,
        loop: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: true,
        dots: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            nav: true,
          },
          600: {
            items: 1,
            nav: false,
            loop: true,
          },
          1000: {
            items: 3,
            loop: true,
          },
        },
      });
    }
  }, 250);

  // Hide cart Quantity
  $(".cart__row").each(function () {
    const text = $(this).find("a.h4.cart__product-name").text();
    if (text.includes("Off Auto renew")) {
      $(this).find(".cart_quantity").css({
        opacity: 0,
        "pointer-events": "none",
      });
    }
  });

  // Mew product page thumbnail function
  $(".imgs-sm img").on("click", function () {
    console.log("thumbnail");
    const url = $(this).attr("src");
    const bigImage = $(".img-lg img");
    bigImage.attr("src", url);
  });

  $("label.rc_label.rc_label__autodeliver").on("click", function () {
    $(".product__quantity.product__quantity--button").css("display", "none");
  });

  $("label.rc_label.rc_label__onetime").on("click", function () {
    $(".product__quantity.product__quantity--button").css("display", "block");
  });

  $("input.rc_radio.rc_radio__autodeliver").on("change", function () {
    $(".product__quantity.product__quantity--button").css("display", "none");
    var prices = $(this).parents('.rc_block__type__autodeliver').find('.money').html();
    var comapre_at = $('.product_price_wrapper').data('compare_at');

    setTimeout(function(){
      $('.product__price--compare').html(theme.Currency.formatMoney(comapre_at, theme.settings.moneyFormat));
      $('.satcb_price,.satcb_price1').html(prices);
    }, 100);
  });

  $("input.rc_radio.rc_radio__onetime").on("change", function () {
    var price = $(this).parents('.rc_block__type__onetime').find('.money').html();
    var comapre_at = $('.product_price_wrapper').data('compare_at');
    $(".product__quantity.product__quantity--button").css("display", "block");

    setTimeout(function(){
      $('.satcb_price,.satcb_price1').html(price);
      $('.product__price--compare').html(theme.Currency.formatMoney(comapre_at, theme.settings.moneyFormat));
    }, 100);
  });

  $(window).on("load", function() {
    setTimeout(function(){
      if($('[name="purchase_type"]').length > 0){
        $('.satcb_price .money,.satcb_price1').html($('[name="purchase_type"]:checked').closest('.rc_block__type').find('.money').text());
        var comapre_price = $('.product_price_wrapper').data('compare_at');
        //console.log('comapre_at--',theme.Currency.formatMoney(comapre_price, theme.settings.moneyFormat));
        var compare_price_html = theme.Currency.formatMoney(comapre_price, theme.settings.moneyFormat);

        $('.product__price.product__price--compare').html(compare_price_html);
      }
    }, 200);
  });

  // Date time function
  function getTimeRemaining(endtime) {
    // console.log(endtime);
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
      total,
      days,
      hours,
      minutes,
      seconds,
    };
  }

  function initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    const daysSpan = clock.querySelector(".days");
    const hoursSpan = clock.querySelector(".hours");
    const minutesSpan = clock.querySelector(".minutes");
    const secondsSpan = clock.querySelector(".seconds");

    function updateClock() {
      const t = getTimeRemaining(endtime);

      daysSpan.innerHTML = t.days;
      hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
      minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
      secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);

      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }

    updateClock();
    const timeinterval = setInterval(updateClock, 1000);
  }

  // const day_admin = document.querySelector('.admin_days').innerText;
  // const admin_hours = document.querySelector('.admin_hours').innerText;
  // const admin_minutes = document.querySelector('.admin_minutes').innerText;
  const adminYear = document.querySelector(".admin_year"),
    adminMonth = document.querySelector(".admin_month"),
    adminDay = document.querySelector(".admin_day");

  if (adminYear && adminMonth && adminDay) {
    const adminYearText = adminYear.innerText,
      adminMonthText = adminMonth.innerText,
      adminDayText = adminDay.innerText;

    const adminDate = new Date(+adminYearText, +adminMonthText, +adminDayText);
    // console.log(adminDate);
    initializeClock("data_counter", adminDate);
    initializeClock("data_counter_ingredients", adminDate);
  }

  const today = new Date(),
    cookiesTime = moment(today).format("YY-MM-DD hh:mm:ss"),
    nowTime = moment(today).format("YY-MM-DD hh:mm:ss");

  let cookieValue = null;

  // if (document.cookie.indexOf('moerie-time') == -1) {

  // } else {
  //     cookieValue = document.cookie
  //         .split('; ')
  //         .find(row => row.startsWith('moerie-time'))
  //         .split('=')[1];

  // }

  // Set Time Cookie for new Vistitor
  setTimesCookies();
   
  // Start time for Black Friday
  function setTimesCookies() {
    
   //console.log('blackFridayId',localStorage.getItem(blackFridayId)); 
    
    if( $('.black_friday_timer').length > 0){

      if( blackFridayId != null ){
        //const checkProductId = localStorage.getItem(blackFridayId),
        const checkProductId = getWithExpiry(blackFridayId),
              displayMinutes = document.querySelector(".black_friday_minutes"),
              displaySeconds = document.querySelector(".black_friday_seconds");
        // console.log(blackFridayId);
        // console.log(checkProductId);
        if (checkProductId) {
          const productStartTime = moment(
            getWithExpiry(blackFridayId),
            "YY-MM-DD hh:mm:ss"
          );
          const productEndTime = moment(nowTime, "YY-MM-DD hh:mm::ss");
          const differenceSeconds = productEndTime.diff(
            productStartTime,
            "seconds"
          );

          let secondsLeft = 0;
          if (differenceSeconds < 900) {
            secondsLeft = 900 - differenceSeconds;
            startTimer(secondsLeft, displayMinutes, displaySeconds);
          }
        } else {
          const now = new Date();
          const item = {
            value: cookiesTime,
            expiry: now.getTime() + 900000,
          };
          localStorage.setItem(blackFridayId, JSON.stringify(item));
          startTimer(15 * 60, displayMinutes, displaySeconds);
        }
      }
    }
  }

  // const start = moment(cookieValue, 'YY-MM-DD hh:mm:ss');
  // const end = moment(nowTime, 'YY-MM-DD hh:mm::ss');
  // let minutes = 0;
  // const diff = end.diff(start, 'minutes');
  // if (diff < 15) {
  //     minutes = 15 - diff;

  //     // setClock();
  //     display = document.querySelector('.black_friday_timer');
  //     startTimer(minutes * 60, display);
  // }

  // const deadline = new Date(Date.parse(new Date()) + (+day_admin) * (+admin_hours) * (+admin_minutes) * 60 * 1000);
  // console.log(adminDate);
  // const zoomedImage = $('.gift_image_wrapper');

  // if (zoomedImage) {
  //     zoomedImage[0].addEventListener('mousemove', ev => {
  //         const force = 70;
  //         const dx = -ev.clientX / window.innerWidth * force;
  //         const dy = -ev.clientY / window.innerHeight * force;
  //         // console.log(dx, dy);
  //         $('.zoomed_image_hover')[0].style.left = dx + 'px';
  //         $('.zoomed_image_hover')[0].style.top = dy + 'px';

  //     });
  // }

  // Function for back Countdown
  function startTimer(duration, displayMinutes, displaySeconds) {
    var timer = duration,
      minutes,
      seconds;
    setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      displayMinutes.textContent = minutes + " minutes";
      displaySeconds.textContent = seconds + " seconds";

      if (--timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  // get Item From Local Storage
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }


   $(".collapsible-content__inner .footer__collapsible ul.site-footer__linklist li").each(function() {
     if($(this).find('a').text() == 'Cookie Preferences')
     {
       $(this).click(function(e){
         e.preventDefault();
         $('.cc-btn.cc-settings').trigger('click');
       })
     }
   });
  
	//ultimate Product
});
$(document).ready(function() {
  var selector = $('.georgitest123');
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 1500);
  }
  ALAcheck();
  function customALA() {
    clearInterval(isALARendered);          
    $('.georgitest123').slick({
      slidesToShow: 3,
      infinite: false,
      arrows: true,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }


  var divLenght= $('.customer-photo').length;
  var cnt=3;
  $('div.customer-photo:gt(2)').hide();
  $('.loadmore').on('click', function (e) {
    e.preventDefault();
    cnt = cnt+3;
    $('div.customer-photo').slice(0,cnt).slideDown();
    if(divLenght <= cnt )
    {
      $('.loadmore').hide();
    }
  });

  $('.yotpo-stars').click(function(){
    $('html, body').animate({
      scrollTop: $(".ultimate-reviews-section").offset().top
    }, 2000);
  });



});




thumbnails();



function thumbnails()
{

  if ($(window).width() < 769) {

    let interval = null
    let domWorks = () => {
      console.log('called 1');
      let d = document.querySelector('.template-ultimate-minerals .mainproductimages')
      if(d){
        $('.template-ultimate-minerals .product__thumbs').removeClass('small--hide');
        $('.template-ultimate-minerals .mainproductimages').slick('unslick');
        setTimeout(function() {
          $('.template-ultimate-minerals .mainproductimages').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            vertical:false,            
            adaptiveHeight:false,
            asNavFor: '.template-ultimate-minerals .product__thumbs'
          });
          
          $('.template-ultimate-minerals .product__thumbs').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.template-ultimate-minerals .mainproductimages',
            dots: true,
            infinite: false,
            speed: 500,
            adaptiveHeight: false,
            focusOnSelect: true,
            arrows: false
          });
        },700);

        clearInterval(interval) // Change it via reference
        console.log('called 2');
      }
    }
    interval = setInterval(domWorks, 100)
  }
  
}



$('.benefits-slider').slick({
  infinite: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$(".title-link-wrap a").click(function(){
  $("body").addClass("popup-active");
  $(".benefits-popup").addClass("active");
  $(".product-overlay").addClass("active");
});
$(".popup_clsoe_icon, .product-overlay").click(function(){
  $("body").removeClass("popup-active");
  $(".benefits-popup").removeClass("active");
  $(".product-overlay").removeClass("active");
});



if ($(window).width() < 769) {

      var found = document.querySelector('.product-ultimate-pills .mainproductimages');
      if(found){
        $('.product-ultimate-pills .product__thumbs').removeClass('small--hide');
        
          $('.product-ultimate-pills .mainproductimages').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            vertical:false,            
            adaptiveHeight:false,
            asNavFor: '.product-ultimate-pills .product__thumbs'
          });
          
          $('.product-ultimate-pills .product__thumbs').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.product-ultimate-pills .mainproductimages',
            dots: true,
            infinite: false,
            speed: 500,
            adaptiveHeight: false,
            focusOnSelect: true,
            arrows: false
          });
      }
    
  }

